module.exports = __webpack_public_path__ + "img/aerialito-white.5eb96f6e.png";